import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Layout,
  theme,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  Checkbox,
  Spin,
  Col,
} from "antd";
import { useNavigate, useLocation } from "react-router-dom";

//PROJECT IMPORTS
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";
import TextArea from "antd/lib/input/TextArea";
import TopContent from "../../../components/layouts/TopContent";
import appStatic from "../../../config/appStatic";
import appLabel from "../../../config/appLabel";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import definedApi from "../../../services/definedApi";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

const EditGLA0400 = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;

  const navigate = useNavigate();
  const { newGLItems, statusData } = appStatic;

  const dispatch = useDispatch();
  const { state } = useLocation();

  const [financialActivityData, setFinancialActivityData] = useState([]);
  const [accountData, setAccountData] = useState([]);
  const [accountingDetail, setAccountingDetail] = useState({});
  const [glDetail, setGlDetail] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [useForm] = Form.useForm();
  const financialActivityOption = Form.useWatch("financialActivityId", useForm);
  const financialActivityGlType = financialActivityData.find(
    (item) => financialActivityOption === item?.value
  )?.mappedGLAccountType;
  console.log(financialActivityGlType, financialActivityOption, financialActivityData);
  useEffect(() => {
    // console.log(useForm);
    getTemplate();
    getDetailById(state);
    //ACTIVATE SAVE RIGHTSIDEBAR ACTION
    // dispatch({
    //   type: cnt.RIGHT_SAVE_BTN,
    // });
  }, []);

  function onCancel() {
    navigate("/gla0400", { replace: false });
  }

  const getDetailById = (params) => {
    setIsLoading(true);

    const url = `${definedApi.GetGLMappingList}/${params.key}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objDetail = res;
        setGlDetail(objDetail);

        // SHOW THE SAVED DATA
        useForm.setFieldsValue({
          financialActivityId: objDetail?.financialActivityData?.id,
          glAccountId: objDetail?.glAccountData?.name,
        });

        setIsLoading(false);
      }
    });
  };

  function getTemplate() {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.GlMappingTemplate, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;
        let tempFinancialActivity = [];
        setAccountingDetail(objList?.glAccountOptions);

        // console.log(objList);

        objList?.financialActivityOptions?.forEach((element) => {
          tempFinancialActivity.push({
            value: element.id,
            // label: appStatic.financialActivityLabelMapping[element.name] || element.name,
            label: element.name,
            mappedGLAccountType: element.mappedGLAccountType,
          });
        });

        setFinancialActivityData(tempFinancialActivity);
      }
    });
  }

  function onSelectFinancialActivity(key, objParam) {
    const acctType = financialActivityGlType?.toLowerCase();
    console.log(objParam);
    let tempAccount = [];

    switch (acctType) {
      case "asset":
        accountingDetail?.assetAccountOptions?.forEach((element) => {
          tempAccount.push({
            value: element.id,
            label: element.name,
          });
        });
        break;
      case "liability":
        accountingDetail?.liabilityAccountOptions?.forEach((element) => {
          tempAccount.push({
            value: element.id,
            label: element.name,
          });
        });
        break;
      case "equity":
        accountingDetail?.equityAccountOptions?.forEach((element) => {
          tempAccount.push({
            value: element.id,
            label: element.name,
          });
        });
        break;

      default:
        break;
    }

    setAccountData(tempAccount);
  }

  React.useEffect(() => {
    onSelectFinancialActivity(financialActivityGlType);
  }, [financialActivityGlType]);

  const onSubmit = (formValues) => {
    const url = `${definedApi.EditGLMappingList}/${state.key}`;

    const body = {
      ...formValues,
      method: "PUT",
      session,
    };

    // console.log(body);return
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, appLabel.editGLMappingMsg);
          navigate("/gla0400");
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/gla0400");
          setIsLoading(false);
        },
      }
    );
  };

  return (
    <MainLayout isEnableRightSidebar={false}>
      <TopContent pageTitle={appLabel.editGLMapping} pageItems={appStatic.editGLMappingItems} />
      <Spin spinning={isLoading} size="large">
        <Card
          title={
            <Title level={4} style={{ color: "#000" }}>
              {appLabel.generalInfo}
            </Title>
          }
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={useForm} layout="vertical" onFinish={onSubmit}>
            <Card
              style={{
                marginBottom: "3%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
              }}
              bordered
            >
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Form.Item
                    name="financialActivityId"
                    label={<Text strong>{appLabel.financialActivity}</Text>}
                  >
                    <Select
                      placeholder="Please Select an option"
                      // style={{ width: "30vh" }}
                      options={financialActivityData}
                      showSearch
                      onChange={() => useForm.setFieldValue("glAccountId", undefined)}
                      // onChange={onSelectFinancialActivity}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name="glAccountId" label={<Text strong>{appLabel.account} </Text>}>
                    <Select
                      placeholder="Please Select an option"
                      // style={{ width: "30vh" }}
                      options={accountData}
                      showSearch
                    />
                  </Form.Item>
                </Col>

                {/* <div style={{ width: "30vh" }}></div> */}
              </Row>
            </Card>
            <Form.Item>
              <Row>
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />
                <CustomButton
                  content="Cancel"
                  style={{
                    width: "10%",
                    marginLeft: "1%",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  backgroundColor="#fff"
                  colorText="black"
                  hoverBackground="#F5F5F5"
                  onClick={onCancel}
                />
              </Row>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(EditGLA0400);
